import "./index55.mjs";
import "./index56.mjs";
import { isLiteralElement as w, isPoundElement as O, isArgumentElement as D, isDateElement as L, isDateTimeSkeleton as I, isTimeElement as N, isNumberElement as A, isNumberSkeleton as P, isTagElement as k, isSelectElement as x, isPluralElement as C } from "./index57.mjs";
import { MissingValueError as G, InvalidValueTypeError as R, InvalidValueError as j, FormatError as V, ErrorCode as X } from "./index54.mjs";
var e;
(function(n) {
  n[n.literal = 0] = "literal", n[n.object = 1] = "object";
})(e || (e = {}));
function q(n) {
  return n.length < 2 ? n : n.reduce(function(r, p) {
    var u = r[r.length - 1];
    return !u || u.type !== e.literal || p.type !== e.literal ? r.push(p) : u.value += p.value, r;
  }, []);
}
function z(n) {
  return typeof n == "function";
}
function d(n, r, p, u, f, l, m) {
  if (n.length === 1 && w(n[0]))
    return [
      {
        type: e.literal,
        value: n[0].value
      }
    ];
  for (var o = [], c = 0, g = n; c < g.length; c++) {
    var t = g[c];
    if (w(t)) {
      o.push({
        type: e.literal,
        value: t.value
      });
      continue;
    }
    if (O(t)) {
      typeof l == "number" && o.push({
        type: e.literal,
        value: p.getNumberFormat(r).format(l)
      });
      continue;
    }
    var b = t.value;
    if (!(f && b in f))
      throw new G(b, m);
    var i = f[b];
    if (D(t)) {
      (!i || typeof i == "string" || typeof i == "number") && (i = typeof i == "string" || typeof i == "number" ? String(i) : ""), o.push({
        type: typeof i == "string" ? e.literal : e.object,
        value: i
      });
      continue;
    }
    if (L(t)) {
      var y = typeof t.style == "string" ? u.date[t.style] : I(t.style) ? t.style.parsedOptions : void 0;
      o.push({
        type: e.literal,
        value: p.getDateTimeFormat(r, y).format(i)
      });
      continue;
    }
    if (N(t)) {
      var y = typeof t.style == "string" ? u.time[t.style] : I(t.style) ? t.style.parsedOptions : u.time.medium;
      o.push({
        type: e.literal,
        value: p.getDateTimeFormat(r, y).format(i)
      });
      continue;
    }
    if (A(t)) {
      var y = typeof t.style == "string" ? u.number[t.style] : P(t.style) ? t.style.parsedOptions : void 0;
      y && y.scale && (i = i * (y.scale || 1)), o.push({
        type: e.literal,
        value: p.getNumberFormat(r, y).format(i)
      });
      continue;
    }
    if (k(t)) {
      var F = t.children, E = t.value, v = f[E];
      if (!z(v))
        throw new R(E, "function", m);
      var S = d(F, r, p, u, f, l), a = v(S.map(function(h) {
        return h.value;
      }));
      Array.isArray(a) || (a = [a]), o.push.apply(o, a.map(function(h) {
        return {
          type: typeof h == "string" ? e.literal : e.object,
          value: h
        };
      }));
    }
    if (x(t)) {
      var s = t.options[i] || t.options.other;
      if (!s)
        throw new j(t.value, i, Object.keys(t.options), m);
      o.push.apply(o, d(s.value, r, p, u, f));
      continue;
    }
    if (C(t)) {
      var s = t.options["=".concat(i)];
      if (!s) {
        if (!Intl.PluralRules)
          throw new V(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, X.MISSING_INTL_API, m);
        var T = p.getPluralRules(r, { type: t.pluralType }).select(i - (t.offset || 0));
        s = t.options[T] || t.options.other;
      }
      if (!s)
        throw new j(t.value, i, Object.keys(t.options), m);
      o.push.apply(o, d(s.value, r, p, u, f, i - (t.offset || 0)));
      continue;
    }
  }
  return q(o);
}
export {
  e as PART_TYPE,
  d as formatToParts,
  z as isFormatXMLElementFn
};
